export default "__VITE_ASSET__f8IEdMJb__"